import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { Field, getIn, withFormik, Form } from 'formik';
import { indexDocumentTemplateRequest } from '../../../requests/documentTemplates';
import { DocumentEditor, FormikSelect } from '../../../components';

const documentTypes = [
  { label: 'Finiquito', value: 'work_settlement' },
  { label: 'Resumen de Finiquito', value: 'settlement_summary' },
  { label: 'Carta de Finiquito', value: 'settlement_letter' }
];
class SettlementDocumentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateFilter: '',
      templateOptions: []
    };
  }

  fetchDocumentTemplates = templateFilter => {
    const { dispatch } = this.props;
    console.log(templateFilter);
    indexDocumentTemplateRequest({
      dispatch,
      params: {
        template_type: [templateFilter],
        sort_column: 'name',
        display_length: 150
      },
      successCallback: response => {
        this.setState(prevState => ({
          ...prevState,
          templateOptions: response.data.data
        }));
      }
    });
  };

  render() {
    const { submitVariant, errors, touched, setFieldValue, isSubmitting, setFieldTouched } = this.props;
    const { templateOptions } = this.state;
    return (
      <>
        <Form>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Field name="templatePdf[documentType]">
                  {({ field }) => (
                    <FormikSelect
                      {...field}
                      abbr
                      label="Tipo de Documento"
                      placeholder="Seleccionar Tipo de Documento"
                      options={documentTypes}
                      onChange={data => {
                        setFieldValue(field.name, data ? data.value : '');
                        setFieldValue('templatePdf[templateId]', '');
                        this.fetchDocumentTemplates(data.value);
                      }}
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                    />
                  )}
                </Field>
              </Col>
              <Col md={6}>
                <Field name="templatePdf[templateId]">
                  {({ field }) => (
                    <FormikSelect
                      {...field}
                      abbr
                      label="Plantilla"
                      options={templateOptions}
                      placeholder="Seleccionar Plantilla"
                      onChange={data => setFieldValue(field.name, data ? data.value : '')}
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                    />
                  )}
                </Field>
              </Col>
              <Col md={12}>
                <Field name="templatePdf[extraKeys][0][value]">
                  {({ field }) => (
                    <DocumentEditor
                      label="Cláusulas Adicionales"
                      onEditorChange={content => setFieldValue(field.name, content)}
                      onBlur={() => setFieldTouched(field.name, true)}
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                    />
                  )}
                </Field>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" className="btn" variant={submitVariant} disabled={isSubmitting}>
              Crear
            </Button>
          </Modal.Footer>
        </Form>
      </>
    );
  }
}

const setInitialValues = () => {
  return {
    templatePdf: {
      documentType: 'payroll_settlement',
      templateId: '',
      extraKeys: [{ code: '[[clausula_adicional_finiquito]]', value: '' }]
    }
  };
};

const validationSchema = Yup.object().shape({
  templatePdf: Yup.object().shape({
    templateId: Yup.string().required('Debes seleccionar una plantilla'),
    documentType: Yup.string().required('Debes seleccionar un tipo de Documento')
  })
});

const handleSubmit = (values, { props }) => {
  const { formRequest, settlementId } = props;
  formRequest(values, settlementId);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: true,
  validateOnMount: false
})(connect()(SettlementDocumentForm));
